// removed by extract-text-webpack-plugin
module.exports = {"error-page-wrap":"_eprJ","error-heading":"_21kl","error-para":"_FpRv","retry-btn":"_3F0r"};


//////////////////
// WEBPACK FOOTER
// ./checkout/components/error/style.css
// module id = x75c
// module chunks = 4